var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdmin = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6D6D78"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-43 -506) translate(16 188) translate(1 300) translate(17 10) translate(9 8) translate(4.583 1.833)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.417,
  cy: 3.667,
  r: 3.667
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.978 18.333H.856c-.473 0-.856-.355-.856-.793v-4.71C0 9.953 2.515 7.62 5.618 7.62h1.597c3.103 0 5.618 2.333 5.618 5.212v4.709c0 .438-.383.793-.855.793z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 9.017L6.417 7.333 4.583 9.017 5.972 10.292 5.12 11.398 6.417 16.857 7.713 11.398 6.862 10.292z"
})))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdmin);
export default ForwardRef;